import ProductSet from '../productSet';
import ProductSetWidget from '../types/productWidget';
import { ProductSetProps } from '../types/productProps';

window.BigCommerce = window.BigCommerce || {};

window.BigCommerce.initializeProductSet = (props: ProductSetProps): ProductSetWidget => {
    return new ProductSet(props);
};
